import type { UserPlatformProfile } from "types/interfaces/user";

export function normPath(s: string): string {
  return (s || "").replace(/\/+$/, "");
}

export function downloadQueueItemKey(item: { fsource: string }): string {
  return normPath(item.fsource || "");
}

export function isTopDocumentFolderDownloadTarget(
  item: { ftype: string; fsource: string },
  clientFolderPrefix: string | null | undefined,
): boolean {
  if (!clientFolderPrefix || item.ftype !== "folder") return false;
  const root = normPath(clientFolderPrefix);
  if (!root) return false;

  const src = normPath(item.fsource);
  if (!(src === root || src.startsWith(root + "/"))) return false;
  const rel = src === root ? "" : src.slice(root.length + 1);
  if (!rel) return false;
  const segments = rel.split("/").filter(Boolean);
  return segments.length === 1;
}

export function mayDownloadTopFolderProfile(
  p: UserPlatformProfile | null | undefined,
): boolean {
  if (!p) return false;
  if (p.is_superuser || p.is_calibrate_manager || p.user_type === "internal")
    return true;
  return !!(p.is_data_storage_user && p.can_download_top_document_folders);
}
